import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatearImporte'
})
export class FormatearImportePipe implements PipeTransform {

  transform(value: any): number
  {
    return parseFloat(value.replaceAll(".", "").replaceAll(",", "."));
  }

}
